var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"example"},[_c('a-spin')],1),_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('a-skeleton',{attrs:{"active":"","paragraph":{rows:3,width:['90%','90%','50%']},"title":false}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }